<template>
  <div>
    <job-management :id="jobId" />
  </div>
</template>

<script>
import AppLibrary from "@/app/Helpers/AppLibrary";

export default {
  name: "WorkspaceView",
  extends: AppLibrary,

  mounted() {

    },
  computed:{
    jobId(){
      return this.$attrs['props'].jobId;
    },
    companyId(){
      return this.$attrs['props'].companyId;
    },
  }

}
</script>